// File: GSTServices.jsx
import React from "react";

export default function GSTServices() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            GST Services (Registration, Returns, GSTR-9, E-Invoice, E-Way Bill, ITC)
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks offers complete GST compliance solutions.
          </p>
          <p className="text-gray-700">
            Full GST lifecycle management including registration, monthly/quarterly returns, GSTR-9 annual return, e-invoicing, e-way bill generation, ITC reconciliation, and audit support.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: GST compliance - tax documents/invoicing) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Complete GST compliance services"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation handling for seamless GST compliance.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>GST login credentials</li>
                <li>Invoices and sales data</li>
                <li>Returns and purchase records</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Error-free GST management with proven expertise across all GST compliance requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Complete GST Registration & Returns
                </h3>
                <p className="text-gray-700 text-sm">
                  GST registration within 3-7 days, GSTR-1/3B monthly/quarterly filings, GSTR-9 annual returns, amendment filings, cancellation support, and multi-state GSTIN management.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  E-Invoicing & E-Way Bill Automation
                </h3>
                <p className="text-gray-700 text-sm">
                  E-invoice generation for turnover >5 Cr, IRN validation, E-way bill bulk generation, vehicle routing optimization, GST portal integration, and real-time compliance tracking.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  ITC Reconciliation & Audit Support
                </h3>
                <p className="text-gray-700 text-sm">
                  GSTR-2A/2B ITC reconciliation, mismatch resolution, refund applications, assessment support, notice responses, appellate tribunal representation, and GST audit preparation.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
